// extracted by mini-css-extract-plugin
var _1 = "LabelListItemContent-modulehover__AuAdP";
var _2 = "LabelListItemContent-modulelabel__Fncab";
var _3 = "LabelListItemContent-moduletext__omb1S";
export { _1 as "hover", _2 as "label", _3 as "text" }
